import React, { Component } from 'react';
import PropTypes from 'prop-types';


class SkipToContent extends Component {

  static getDomId() {
    return 'slot_skip_to_content';
  }

  constructor(props) {
    super(props);
    this.state = {
      isContentAvailable: false,
    };
  }

  componentDidMount() {
    this.setState({
      isContentAvailable: !!document.getElementById('main'),
    });
  }

  render() {
    const { buttonText } = this.props;

    if (!this.state.isContentAvailable) {
      return null;
    }

    return (
      <span className="skip-link-wrapper">
        <a href="#main" className="skip-link">{buttonText}</a>
      </span>
    );
  }
}

SkipToContent.propTypes = {
  buttonText: PropTypes.string.isRequired,
};

export default SkipToContent;
